import React, {useEffect} from 'react';

import FormControl from '@mui/joy/FormControl';
import Grid from '@mui/joy/Grid';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';

export default function Quote(props) {	
	const [quote, setQuote] = React.useState(0);
	
	useEffect(() => {
		props.handleClick(props.activeCard && quote > 0, quote);			
	}, [props.activeCard]);


	function handleChange(e) {
		setQuote(e.target.value);
		props.handleClick(props.activeCard && e.target.value > 0, e.target.value);			
	}

	return (
	    <FormControl>
	    	<Grid container xs={4}>
	            <FormLabel>Price</FormLabel>
				<Input type="number" variant="solid" autoFocus disabled={!props.activeCard} size="lg" onChange={(e) => {handleChange(e);}} onWheel={(e) => e.target.blur()}/>
			</Grid>
		</FormControl>
	)
}